
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { gsap } from 'gsap';
import ScrollMagic from 'scrollmagic';
import 'scrollmagic-plugins';
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";
import ScrollMagicPluginIndicator from 'scrollmagic-plugins/plugins/debug.addIndicator';
import Lenis from 'lenis';
import { Flip } from "gsap/Flip";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(Flip);
Fancybox.bind("[data-fancybox]", {
	loop: true,
	arrows: true,
})

function observeElements(selector, className, options = {}) {
	const defaultOptions = {
		threshold: 0.1,
		rootMargin: '0px',
		once: true // Добавлять класс только один раз
	};

	const config = { ...defaultOptions, ...options };

	const elements = document.querySelectorAll(selector);

	if (!elements.length) return;

	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				entry.target.classList.add(className);

				// Если нужно наблюдать только один раз
				if (config.once) {
					observer.unobserve(entry.target);
				}
			} else if (!config.once) {
				// Убираем класс, если элемент вышел из зоны видимости
				entry.target.classList.remove(className);
			}
		});
	}, {
		threshold: config.threshold,
		rootMargin: config.rootMargin
	});

	elements.forEach(element => {
		observer.observe(element);
	});

	return observer;
}


ScrollMagicPluginGsap(ScrollMagic, gsap);


const lenis = new Lenis({
	lerp: 0.1,
	smoothWheel: true,
	smooth: window.innerWidth<900?false:true,
	orientation: 'vertical',
	allowNestedScroll: true
})

if(document.querySelector('.front-top')){if (ScrollTrigger.isTouch === 1) {
    ScrollTrigger.normalizeScroll(true);
}
// Функция для перевода vw в пиксели
const vwToPx = (vw) => (window.innerWidth * vw) / 100;

// Получаем элементы
const layer1 = document.querySelector('.front-top__layer-1');
const layer2 = document.querySelector('.front-top__layer-2');
const layer3 = document.querySelector('.front-top__layer-3-wrap');
const layer4 = document.querySelector('.front-top__text');
const search = document.querySelector('.front-top__search');
const section = document.querySelector('.front-top'); // триггер-секция

// Уничтожаем предыдущие анимации при ресайзе
let scrollTriggers = [];
//  ScrollTrigger.normalizeScroll(true);
 if (ScrollTrigger.isTouch === 1) {
    ScrollTrigger.config({
        ignoreMobileResize: false  // Заставляем реагировать на изменение высоты окна
    });
}
function initParallax() {
	// Удаляем старые ScrollTrigger и анимации
	scrollTriggers.forEach(st => st.kill());
	scrollTriggers = [];

	// Вычисляем конечные смещения в пикселях
	const move1 = -vwToPx(3);   // -1vw вверх
	const move2 = -vwToPx(-3);  // -10vw вверх
	const move3 = -vwToPx(5);  // -20vw вверх
	let mult = window.innerWidth>600?2.5:1;
	ScrollTrigger.create({
		trigger: ".front-top__layer-3",          // элемент, который будет зафиксирован
		start: "bottom bottom",     // когда низ элемента касается низа окна – начинаем пин
		end: document.querySelector('.block-promotions').getBoundingClientRect().top - window.innerHeight  - 40,              // продолжительность фиксации – 2 высоты экрана
		pin: true,                  // фиксируем элемент на время от start до end
		pinType: "transform",
		pinSpacing: true,           // добавляем отступ, чтобы контент не наезжал

		// Опционально – маркеры для отладки (убрать в production)
		// markers: true,
	});
	// Анимация для .front-top__layer-1
	const st1 = gsap.to(layer1, {
		y: move1,
		ease: "none",
		scrollTrigger: {
			trigger: section,
			start: "top top",
			end: "+=100vh",   
			scrub: true,
			invalidateOnRefresh: true // поможет при ресайзе
		}
	});
	scrollTriggers.push(st1.scrollTrigger);

	// Анимация для .front-top__layer-2
	const st2 = gsap.to(layer2, {
		y: move2,
		ease: "none",
		scrollTrigger: {
			trigger: section,
			start: "top top",
			end: "+=150vh",   
			scrub: true,
			invalidateOnRefresh: true
		}
	});
	scrollTriggers.push(st2.scrollTrigger);

	// Анимация для .front-top__layer-3
	const st3 = gsap.to(layer3, {
		y: 0,
		ease: "none",
		scrollTrigger: {
			trigger: section,
			start: "top top",
			end: "+200vh",   
			scrub: true,
			invalidateOnRefresh: true
		}
	});
	scrollTriggers.push(st3.scrollTrigger);
	// Анимация для .front-top__layer-3
	const st4 = gsap.to(layer4, {
		y: 0,
		ease: "none",
		scrollTrigger: {
			trigger: section,
			start: "top top",
			end: "+100vh",   
			scrub: true,
			invalidateOnRefresh: true
		}
	});
	const st = gsap.to(search, {
		marginTop: '0%',
		ease: "none",
		scrollTrigger: {
			trigger: section,
			start: "top top",
			end: "+200vh",   
			scrub: true,
			invalidateOnRefresh: true
		}
	});
	scrollTriggers.push(st.scrollTrigger);


window.addEventListener('load', () => {
    ScrollTrigger.refresh();  // Пересчитываем все позиции
});

// Если используете изображения, можно дополнительно:
document.querySelectorAll('img').forEach(img => {
    img.addEventListener('load', () => ScrollTrigger.refresh());
});
}

// Инициализация анимации
initParallax();

// Обновляем анимацию при изменении размера окна (пересчёт vw в px)
let resizeTimer;
window.addEventListener('resize', () => {
	clearTimeout(resizeTimer);
	resizeTimer = setTimeout(() => {
		initParallax();
		// Обновляем все ScrollTrigger, чтобы пересчитать позиции
		ScrollTrigger.refresh();
	}, 150);
});
}
// 2. Инициализация ScrollMagic
const controller = new ScrollMagic.Controller({
	addIndicators: true,
	refreshInterval: 0, // Отключаем авто-обновление
})

// 3. Связывание Lenis и ScrollMagic
lenis.on('scroll', ({ scroll }) => {
	ScrollTrigger.update();
	const scrollEvent = new CustomEvent('scroll', {
		detail: {
			target: { scrollTop: scroll }
		}
	});

	// Вызываем обработчик скролла у контроллера
	if (typeof controller._onScroll === 'function') {
		controller._onScroll(scrollEvent);
	}

})

// 4. Обработка ресайза
window.addEventListener('resize', () => {
	controller.update(true)
})

// 5. Анимационный цикл
function raf(time) {
	lenis.raf(time)
	requestAnimationFrame(raf)
}

requestAnimationFrame(raf)



// Функция для обработки iframe
function handleIframes() {
	// Находим все iframe на странице
	const iframes = document.querySelectorAll('.no-scroll')

	iframes.forEach(iframe => {
		// При наведении на iframe - останавливаем Lenis
		iframe.addEventListener('mouseenter', () => {
			lenis.stop()
		})

		// При уходе с iframe - возобновляем Lenis
		iframe.addEventListener('mouseleave', () => {
			lenis.start()
		})
	})
}
document.addEventListener('DOMContentLoaded', handleIframes)



observeElements('.text', '_visible', {
	threshold: 0.2,
	once: true
});




if(document.querySelector('#gallery-1')  && window.innerWidth>600){
// Function to trigger Flip animations when scrolling
const triggerFlipOnScroll = (galleryEl, options) => {
    let settings = {
        flip: { absoluteOnLeave: false, absolute: false, scale: true, simple: true },
        scrollTrigger: { start: 'top top', end: '+=150%', pin: true, pinSpacing: true },
        stagger: 0
    };
    settings = Object.assign({}, settings, options);

    const galleryCaption = galleryEl.querySelector('.caption');
    const galleryItems = galleryEl.querySelectorAll('.gallery__item');
    const galleryItemsInner = [...galleryItems].map(item => [...item.children]).flat();

    // Принудительно скрываем caption перед началом анимации
    if (galleryCaption) {
        gsap.set(galleryCaption, {
            scale: 0,
            xPercent: 50,
            yPercent: 50,
            opacity: 0,
            rotation: 0
        });
    }

    galleryEl.classList.add('gallery--switch');
    const flipstate = Flip.getState(galleryItems, { props: 'filter, opacity' }); // caption исключён
    galleryEl.classList.remove('gallery--switch');

    const tl = Flip.to(flipstate, {
        ease: 'none',
        absoluteOnLeave: settings.flip.absoluteOnLeave,
        absolute: settings.flip.absolute,
        scale: settings.flip.scale,
        simple: settings.flip.simple,
        scrollTrigger: {
            trigger: galleryEl,
            start: settings.scrollTrigger.start,
            end: settings.scrollTrigger.end,
            pin: galleryEl.parentNode,
            scrub: true,
        },
        stagger: settings.stagger
    });

    if (galleryItemsInner.length) {
        tl.fromTo(galleryItemsInner, { scale: 2 }, { scale: 1, scrollTrigger: { scrub: true } }, 0);
    }

    if (galleryCaption) {
    // Вычисляем момент, когда основная анимация выполнена на 70%
    const startPoint = "top+=20% top";   // 150% * 0.7 = 105% от начала триггера
    gsap.fromTo(galleryCaption,
        { scale: 0, xPercent: -50, yPercent: -50, opacity: 1, rotation: 0 },
        {
            scale: 1, xPercent: -50, yPercent: -50,  opacity: 1, rotation: 0,
            ease: "none",
            scrollTrigger: {
                trigger: galleryEl,
                start: startPoint,
                end: "+=75%",     // анимация займёт последние 30% от оставшегося пути
                scrub: true
            }
        }
    );
}
};

// Function to apply scroll-triggered animations to various galleries
// Apply scroll-triggered animations to each gallery with specific settings
const scroll = () => {
	// Define the gallery IDs and their options 
	const galleries = [
		{ id: '#gallery-1', options: { flip: { absoluteOnLeave: true, scale: false } } },
	];

	// Loop through the galleries and apply the scroll-triggered animations 
	galleries.forEach(gallery => {
		const galleryElement = document.querySelector(gallery.id);
		triggerFlipOnScroll(galleryElement, gallery.options);
	});
}


document.querySelectorAll('.anim-top').forEach(el => {
	
// Анимация для изображения
 gsap.to(".anim-top__img", {
            y: 0, // конечная позиция
            ease: "none",
            scrollTrigger: {
                trigger: 0,
                end: window.innerHeight * 0.9,
                scrub: 1,
                // markers: true, // раскомментируйте для отладки
                onUpdate: (self) => {
                    // Опционально: отслеживаем прогресс анимации
                    console.log(self.progress);
                }
            }
        });

ScrollTrigger.create({
		trigger: el,          // элемент, который будет зафиксирован
		start: "bottom bottom",     // когда низ элемента касается низа окна – начинаем пин
		end: window.innerHeight * 1,              // продолжительность фиксации – 2 высоты экрана
		pin: true,                  // фиксируем элемент на время от start до end
		pinSpacing: true,
	});

})


	scroll();
}